// TODO optimize assets. Render background separately from image on it + add animations.
import rawImageSrcVCard from './images/vcard-background.jpg';
import rawImageSrcFrames from './images/frames-background.jpg';
import rawImageSrcPatterns from './images/patterns-background.jpg';
import rawImageSrcLogos from './images/logos-background.jpg';
import rawImageSrcScans from './images/scans-background.jpg';
import rawAppLogoUrl from '@app/assets/images/app-logo.svg';

import { IS_LOCALHOST } from '@app/environment/typed-env';

// TODO handle for PROD env
const prefix = IS_LOCALHOST ? '' : 'https://widget-trueqrcode-dev.osdb.io';
export const getRawImageUrl = {
  rawImageSrcVCard: `${prefix}${rawImageSrcVCard}`,
  rawImageSrcFrames: `${prefix}${rawImageSrcFrames}`,
  rawImageSrcPatterns: `${prefix}${rawImageSrcPatterns}`,
  rawImageSrcLogos: `${prefix}${rawImageSrcLogos}`,
  rawImageSrcScans: `${prefix}${rawImageSrcScans}`,
  rawAppLogoUrl: `${prefix}${rawAppLogoUrl}`,
};
